module.exports = __webpack_public_path__ + "static/media/Shangrila Numeric Regular.f418b439.ttf";